// helper functions for vuex store

export const paramById = (groups, id) => {
    for (let group of groups) {
        if (group.hasOwnProperty('parameters')) {
            for (let param of group.parameters) {
                if (String(param.id) === String(id)) {
                    return param
                }
            }
        } else if (group.hasOwnProperty('groups')) {
            const found = paramById(group.groups, id)
            if (found) {
                return found
            }
        }
    }
    return false
}

export const paramCallback = (groups, callback) => {
    groups.forEach((group) => {
        if (group.hasOwnProperty('parameters')) {
            for (let param of group.parameters) {
                callback(param)
            }
        } else if (group.hasOwnProperty('groups')) {
            return paramCallback(group.groups, callback)
        }
    })
}

export const prepareFormData = state => {
    let data = {}
    for (const [key, value] of Object.entries(state.formData)) {
        data[key] = (value === undefined) ? null : state.formData[key]
    }
    return {
        data,
        extra: state.globalExtra,
    }
}

export const getIndexById = (arrayOfObjects, id) => arrayOfObjects.findIndex(item => item.id === id)

export const removeItemById = (arrayOfObjects, id) => {
    const index = getIndexById(arrayOfObjects, id)
    if (index !== -1) {
        arrayOfObjects.splice(index, 1)
    }
}

export const updateOrAddItemById = (arrayOfObjects, item) => {
    const index = getIndexById(arrayOfObjects, item.id)
    if (index !== -1) {
        arrayOfObjects[index] = item
    } else {
        arrayOfObjects.splice(arrayOfObjects.length, 1, item)
    }
}

export const getItemById = (arrayOfObjects, id) => {
    const index = getIndexById(arrayOfObjects, id)
    if (index !== -1) {
        return arrayOfObjects[index]
    }
    return false
}

export default {
    paramById,
    paramCallback,
    prepareFormData,
    getIndexById,
    removeItemById,
    updateOrAddItemById,
}
